import Map, { initMapOptions as initopts } from './Map';
export const initMapOptions = initopts;
export default Map;
